export function resolveMobileValue(isMobileContext, base, mobileOverride) {
    return isMobileContext && mobileOverride != null ? mobileOverride : base;
}
